import React, { useRef, useEffect, useState } from "react";
import { Select } from "antd";
import { useHistory } from "react-router-dom";
import jwt from "../../utils/jwt";
import BusinessModelDropdown from "./dropDown"; // Import the dropdown component
import { Fetch } from "../../utils/fetch";
import { shouldShowConsentPopup, markConsentGiven, clearConsent } from "../../utils/consentUtils";
import TrackAgreementsModal from "../agreementTracking/TrackAgreementsModal";

const Header = (props) => {
  const [profileModal, setProfileModal] = useState(false);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [consentLoading, setConsentLoading] = useState(false);

  const modalRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setProfileModal(false);
      }
    };

    if (profileModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileModal]);

  const token = localStorage.getItem("idToken");
  const decodedToken = jwt.decode(token);

  useEffect(() => {
    if (shouldShowConsentPopup()) setShowConsentModal(true);
  }, []);

  const handleConsentAgree = async () => {
    setConsentLoading(true);
    try {
      await Fetch(`/user/updateConsent`, { method: "post" });
      markConsentGiven();
      setShowConsentModal(false);
    } catch (err) {
      console.log(err);
    }
    setConsentLoading(false);
  };
  let userName = decodedToken.name || decodedToken.mgName;
  let userType = decodedToken.userType || "OPERATOR";
  let email = decodedToken.email || decodedToken.mgEmail;

  if (sessionStorage.getItem("userType")) {
    userType = sessionStorage.getItem("userType");
  } else if (decodedToken.mgName) {
    userName = decodedToken.mgName;
  } else if (decodedToken.isElectricUser) {
    userName = decodedToken.electricName;
    userType = "ELECTRIC";
    email = decodedToken.electricEmail;
  }

  if (!userName) {
    userName = decodedToken.adminName || "User";
  }

  const firstLetter = userName ? userName.charAt(0).toUpperCase() : "";

  return (
    <>
      <TrackAgreementsModal />
      {showConsentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "28px 28px 24px",
              width: "360px",
              maxWidth: "90%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div style={{ fontSize: "36px" }}>⚠️</div>
            <div
              style={{ fontWeight: 700, fontSize: "16px", textAlign: "center" }}
            >
              Confirm your KYC consent
            </div>
            <div
              style={{
                fontSize: "13px",
                color: "#555",
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              zingbus stores your PAN/Aadhaar (encrypted) to verify your eligibility to operate. Please re-confirm your consent to keep your account active.
            </div>
            <button
              onClick={handleConsentAgree}
              disabled={consentLoading}
              style={{
                marginTop: "8px",
                width: "100%",
                padding: "10px 0",
                background: consentLoading ? "#a78bfa" : "#7c3aed",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: consentLoading ? "not-allowed" : "pointer",
              }}
            >
              {consentLoading ? "Please wait..." : "I Agree"}
            </button>
          </div>
        </div>
      )}
      <div className="navHeader">
        <div>
          <img
            className="logo"
            src="https://d1flzashw70bti.cloudfront.net/original/images/header/operatorLogo.svg"
            alt="logo"
          />
        </div>
        <div>
          {userType != "CABOWNER" ? (
            <BusinessModelDropdown
              userType={userType}
              mobileNo={decodedToken.mobileNo}
            />
          ) : null}
          <div
            className="userName"
            onClick={() => setProfileModal(!profileModal)}
            ref={modalRef}
          >
            <span>
              <b>{firstLetter}</b>
            </span>{" "}
          </div>
        </div>
      </div>
      {profileModal ? (
        <div className="profileDetails" ref={modalRef}>
          <div className="userDetails">
            <span className="operatorName">Hi {userName},</span>
            <div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/header/phone.svg"
                alt="phone"
              />
              <span>{decodedToken.mobileNo}</span>
            </div>
            <div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/header/email.svg"
                alt="emailId"
              />
              <span>{email}</span>
            </div>
          </div>
          <div
            className="goto"
            onClick={() => {
              props.routeChange("profile");
            }}
          >
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/header/account.svg"
              alt="profilePhoto"
            />
            <span>Account Details</span>
          </div>

          <div className="logout">
            <div onClick={props.deleteToken}>
              <span>Logout</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default Header;
